import { Map } from 'immutable';
import Constants from '../../constants';
import { ACTION_FETCHING, ACTION_SUCCESS, ACTION_ERROR } from '../../constants/action-status';

export const DEFAULT_STATE = Map({
	query: '',
	isFetching: false,
	isOpen: false,
	results: [],
});

export default function searchQuestions(state = DEFAULT_STATE, action) {
	const { type, payload = {} } = action;
	switch (type) {
		case Constants.QUERY:
			return state.set('query', payload);
		case `${Constants.SEARCH_QUESTIONS}_${ACTION_FETCHING}`:
			return state.set('isFetching', true);
		case `${Constants.SEARCH_QUESTIONS}_${ACTION_SUCCESS}`:
			return state.withMutations((state) => {
				let results = action.payload.results.result.questions;
				if (typeof results === 'string') {
					results = [results];
				}
				state.set('results', results);
				state.set('isFetching', false);
				return state;
			});
		case `${Constants.SEARCH_QUESTIONS}_${ACTION_ERROR}`:
			return state.set('isFetching', false);
		case Constants.SEARCH_OPEN_CHANGED:
			return state.set('isOpen', payload);
		case Constants.CLEAR_SEARCH:
			return DEFAULT_STATE;
		default:
			return state;
	}
}
